const convertUserId = (userId) => {
  // s.hoefler-thierfeldt -> hoefler-thierfeldt_s
  const match = userId.match(/(.*)\.([^\\.]*)/);
  return match == null ? userId : `${match[2]}_${match[1]}`;
};

export default convertUserId;
